import { render, staticRenderFns } from "./CardFront.vue?vue&type=template&id=5ccbe020&scoped=true&"
import script from "./CardFront.vue?vue&type=script&lang=js&"
export * from "./CardFront.vue?vue&type=script&lang=js&"
import style0 from "./CardFront.vue?vue&type=style&index=0&id=5ccbe020&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccbe020",
  null
  
)

export default component.exports